<div class="container-fluid">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
        <p style="color: white"> Please Wait, Registration In Process </p>
    </ngx-spinner>

    <!-- if Registration Open -->
    <mat-card class="example-card">
        <mat-card-header class="justify-content-center">
            <mat-card-title class="title">
                <!-- <img class="event-logo" mat-card-image
                    src="https://aieventzo.com/upload/event_logo/{{event_logo}}" alt="Photo of a Shiba Inu"> -->
                Payment Page</mat-card-title>
        </mat-card-header>
        <img class="event-image" mat-card-image src="https://aieventzo.com/upload/event_image/{{event_image}}"
            alt="Photo of a Shiba Inu">
        <mat-card-content>
            <div class="row">
                <h1>Payment Successful!</h1>
                <p>Thank you for your payment. Your transaction has been successfully processed.</p>

                <p>Dear, <span style="font-size: 26px;" id="fullname">{{name}}</span><br>
                    You have successfully registered to the event {{event_name}}<br>
                    Transaction ID : <span id="tid">{{pid}}</span><br>
                    Order ID: <span id="oid">{{order_id}}</span><br>
                </p>

                <a href="/#/Registration/{{event_id}}">Back To Registration Page</a>
            </div>

            <p></p>
        </mat-card-content>

        <div style="display: flex;align-items: center;margin: 20px;">
            <div class="row">
                <div style="font-weight: 700;margin-right: 20px;">Download
                    Scan Me App :&nbsp;
                    <a href="https://play.google.com/store/apps/details?id=com.vthink.scanme">
                        <img width="25px" height="auto" src="./assets/playstore.png">
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://apps.apple.com/in/app/aieventzo-event-tools/id6448720642">
                        <img width="25px" height="auto" src="./assets/apple.png">
                    </a>
                </div>
            </div>
        </div>
    </mat-card>
</div>
<footer class="bg-black text-white fixed-bottom">
    <div class="text-center">
        Event Ticketing by www.aieventzo.com
    </div>
</footer>